import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCentrifugalPump2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 62.09,
	height: 77,
	viewBox: "0 0 62.09 77.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 12.0 64.0 L 0.0 77.0 L 60.0 77.0 L 48.0 64.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 25.0 69.4 A 30.0 30.0 0.0 0 1 0.0 40.0 L 0.0 0.0 L 20.0 0.0 L 20.0 11.55 A 30.0 30.0 0.0 1 1 35.0 69.4",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 25.0 48.6 A 10.0 10.0 0.0 1 1 35.0 48.6",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgCentrifugalPump2;
